import { Meal } from "@/clients/models/Meal";
import { CutleryIcon } from "@/components/icons/cutlery-icon";
import { FilledButton } from "@/components/ui/buttons";
import { memo, useState } from "react";
import { AddToPlanModal } from "../add-to-plan-modal";

interface YourPlanOptionProps {
  meal: Meal;
  onComplete?: () => void;
}

export const YourPlanOption = memo(function YourPlanOption({
  meal,
  onComplete,
}: YourPlanOptionProps) {
  const [isAddToPlanModalOpen, setIsAddToPlanModalOpen] = useState(false);

  return (
    <>
      <FilledButton
        color="black"
        textCase="normal"
        onClick={() => setIsAddToPlanModalOpen(true)}
        className="flex items-center justify-between gap-3 px-5 py-2"
      >
        <CutleryIcon className="h-6 w-6 fill-white" />
        <span>Your Plan</span>
        <div className="w-6" />
      </FilledButton>

      <AddToPlanModal
        isOpen={isAddToPlanModalOpen}
        onDismiss={() => {
          setIsAddToPlanModalOpen(false);
          onComplete?.();
        }}
        meal={meal}
      />
    </>
  );
});
